
import style from './Loader.module.css';
import LoaderIndicator from "./LoaderIndicator";

interface LoaderScreen {
    message: string
}
export default function LoaderScreen({message}: LoaderScreen) {


  return (
    <div className={style.backdrop}>
      <div className={style.screenInner}>
        <LoaderIndicator id="screen" strokeWidth="3"/>
        <div className={style.screenMessage}>{message}</div>
      </div>
    </div>
  )


}
